import {Component, inject} from '@angular/core';
import {FilterConfig, GridPageComponent} from "../../../common/grid-page.component";
import {BlockedStockException, BlockedStockGridViewDto, BlockedStockStatus, DaysOnHoldType} from "@services";
import {CommonModule} from "@angular/common";
import {
    DxDataGridModule,
    DxFormModule,
    DxTemplateModule
} from "devextreme-angular";
import {FilterPanelComponent} from "../../../../components/library/filter-panel/filter-panel.component";
import EnumUtils from "../../../../shared/enum-utils";
import {DaysOnHoldTypePipe} from "../../../../pipes/days-on-hold-type.pipe";
import {BlockedStockExceptionPipe} from "../../../../pipes/blocked-stock-exception.pipe";

@Component({
    selector: 'app-blocked-stock-data',
    standalone: true,
    imports: [
        CommonModule,
        DxDataGridModule,
        DxFormModule,
        DxTemplateModule,
        FilterPanelComponent
    ],
    providers: [DaysOnHoldTypePipe, BlockedStockExceptionPipe],
    templateUrl: './blocked-stock-data.component.html',
    styles: [
        `.grid {
            height: calc(100vh - 150px);
        }`
    ]
})
export class BlockedStockDataComponent extends GridPageComponent<BlockedStockGridViewDto> {

    private daysOnHoldType = inject(DaysOnHoldTypePipe);
    private blockedStockException = inject(BlockedStockExceptionPipe);

    constructor() {
        super();
        this.init(BlockedStockGridViewDto);
    }

    readonly numberFormat = "#,##0";
    readonly decimalFormat = "#,##0.##";

    dataSource = this.dataSources.blockedStock();

    readonly daysOnHoldOptions = EnumUtils.getEnumOptions(DaysOnHoldType, (v) => this.daysOnHoldType.transform(v));
    readonly statusOptions = EnumUtils.getEnumOptions(BlockedStockStatus);
    readonly exceptionOptions = EnumUtils.getEnumOptions(BlockedStockException, (v) => this.blockedStockException.transform(v));

    protected override exportName: string = "BlockedStock";
    protected override enableDeepLinkDateFilter = true;

    protected override filterConfig: FilterConfig[] = [
        {field: 'material', op: 'contains'},
        {field: 'batch', op: 'contains'},
        {field: 'storageUnit', op: 'contains'},
        {field: 'materialDescription', op: 'contains'},
        {field: 'blocked', op: '>='},
        {field: 'primReasonCodeDes', op: 'contains'},
        {field: 'acdDescription', op: 'contains'},
        {field: 'lastTransferDate', op: '>='},
        {field: 'mTyp', op: 'contains'},
        {field: 'materialGroup', op: 'contains'},
        {field: 'movementType', op: 'contains'},
        {field: 'reason', op: 'contains'},
        {field: 'storageBin', op: 'contains'},
        {field: 'age', op: '>='},
        {field: 'daysOnHold', op: '='},
        {field: 'status', op: '='},
        {field: 'duplicate', op: '='},
        {field: 'exception', op: '='},
        {field: 'created', op: '>='},
        {field: 'lastSeenInUpload', op: '>='},
        {field: 'dateCompleted', op: '>='},
    ];

    protected getStatusBadgeClass(status: BlockedStockStatus): string {
        switch (status) {
            case BlockedStockStatus.Active:
                return 'bg-success-subtle text-success';
            case BlockedStockStatus.Completed:
                return 'bg-secondary-subtle text-secondary';
            default:
                return 'bg-secondary-subtle text-secondary';
        }
    }
}
